export const api_version = 2;
export const build = '2026.10.14.15.18'; 
export const dev_env = false;
export const server = dev_env ? 'http://aft.local' : 'https://aftplatform.com';
export const shopify_domain = 'checkout.getaqualink.com';

export default {
    build: build,
    dev_env: dev_env,
    features: {
        leadCapture: true,
        discountCapture: 'email', // sms|email
    },
    server: server,
    recaptcha: {
        siteKey: '6LfkN-ItAAAAAHHjnqkPCG8MNk6mZgWE1TGZy2Rl',
    },
    shopify: {
        domain: shopify_domain,
        storefrontAccessToken: '1a57995f60ff73a58ffbe711998fb0c2',
        accountUrl: `https://${shopify_domain}/account`,
    },
    social: {
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        twitter: 'https://twitter.com',
        linkedin: 'https://linkedin.com',
    },
    sockets: dev_env ? `${server}:3500` : `https://sockets.aftplatform.com`,
    store: {
        name: 'Aqua Link',
        tagline: 'Smart Home Safety',
        description: 'Protecting what matters most with intelligent safety technology.',
        email: 'support@getaqualink.com',
        phone: '(972) 393-5500',
        website: 'https://getaqualink.com',
    },
    url: `${server}/api/v${api_version}`,
    version: api_version
}
